import React, { useState, useEffect } from 'react'
import { Panel, Row, Icon, Table, ButtonGroup, IconButton } from 'rsuite'

export default function CancelProjectFileViewWidget({ data, onPreview, onDownload, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <>
      <Table autoHeight height={300} wordWrap bordered data={data ? [...data] : []}>
        {/* <Column width={90} align="center" fixed>
          <HeaderCell>ไฟล์ที่</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column> */}
        <Column minWidth={300} flexGrow={1}>
          <HeaderCell>เอกสารแนบประกอบการพิจาณา</HeaderCell>
          <Cell dataKey="label" />
        </Column>

        {/* <Column minWidth={100} flexGrow={1}>
          <HeaderCell>ประเภทไฟล์</HeaderCell>
          <Cell dataKey="contractFileType" />
        </Column> */}

        <Column width={150} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData, index) => {
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      onClick={(e) => onPreview(rowData)}
                      disabled={!rowData?.path}
                    />
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                      onClick={(e) => onDownload(rowData)}
                      disabled={!rowData?.path}
                    />
                  </ButtonGroup>
                )
            }}
          </Cell>
        </Column>
      </Table>
      <br />
    </>
  )
}
